import { baseTheme, deepMerge } from '@devotel/design-system';
import { WhiteLabelConfig } from './types';

export const createCustomTheme = (config: WhiteLabelConfig) => {
  return deepMerge({}, baseTheme, {
    colors: {
      primary: {
        main: { filled: config.primaryColor || '#FD5B2C' },
        linear: { filled: 'transparent', text: '#000000', border: '#aaaaaa' },
      },
      secondary: {
        main: { filled: config.secondaryColor || '#1E90FF' },
        linear: { filled: 'transparent', text: '#000000', border: '#aaaaaa' },
      },
    },
  });
};
